(function (window) {
    if ($('.banner-2-images').length <= 0) {
        return;
    };

    $banner2ImagesSliderButton = $('.banner-2-images__slider__button');
    $banner2ImagesSlider = $('.banner-2-images__slider')

    function toggle2ImageSlider(e) {
        e.preventDefault();
        $banner2ImagesSlider.toggleClass('-active');
    };

    function checkMobileImages() {
        $desktopImages = $('.banner-2-images .desktop-image');
        
        $(".banner-2-images__slider__image").bind("error", function (e) {
            // If an error occurs from loading one of these 2 mobiles images, the desktop version will replace it
            let index = $(this).index();
            let newSrc = $desktopImages[index].src
            $(this).attr("src", newSrc);
          });

    }

    checkMobileImages();

    $banner2ImagesSliderButton.on('click', toggle2ImageSlider);

})(window);
